import React, { useState, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../style/Cxp.css';

const Cxp = () => {
  const [formData, setFormData] = useState({
    producto: 'PTPR02378',
    lote: '1'
  });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [showPrintFormat, setShowPrintFormat] = useState(false);
  
  const printRef = useRef();

  // Lista completa de materiales de empaque
  const materialesEmpaque = [
    { codigo: 'MEMP000356', descripcion: 'Caja # 13, Tapa, Test 200' },
    { codigo: 'MEMP000365', descripcion: 'Caja # 13, Fondo, Test 275' },
    { codigo: 'MEMP000417', descripcion: 'Bolsas Especiales - 20 x 26' },
    { codigo: 'MEMP000738', descripcion: 'Etiqueta Vencimiento Grandes 2026' },
    { codigo: 'MEMP000507', descripcion: 'Grapas C-58 5/8 Marca ZEUS' },
    { codigo: 'MEMP001273', descripcion: 'Etiqueta Polipropileno 50* 100 mm' },
    { codigo: 'MEMP000737', descripcion: 'Cajas para reutilizar' },
    { codigo: 'MEMP000415', descripcion: 'Bolsa 26 Libras - 20 x 26' },
    { codigo: 'MEMP000148', descripcion: 'Bolsa para Blocks de 5 Libras - 10 x 14' }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setShowPrintFormat(false);
    
    const datos = {
      "Token": "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      "Ambiente": "DESA",
      "Dispositivo": {
        "Marca": "SAMSUNG",
        "Modelo": "S22002B",
        "Version": "Android 18.125",
        "McAdress": null,
        "PowerStatus": "84%",
        "WifiStatus": "Conected to iphone de Mauricio",
        "GPSStatus": "ON",
        "GPS": "321|-485|321"
      },
      "Usr": {
        "Codigo": "",
        "UserNickName": "pierril"
      },
      "DatosMetodo": {
        "NombreMetodo": "BusquedaEtiquetas",
        "Datos_Recibidos": JSON.stringify({
          "PRODUCTO": formData.producto,
          "LOTE": formData.lote
        })
      }
    };

    try {
      const response = await fetch(
        `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`,
        { method: 'GET' }
      );
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json(); 
      console.log(data)
      setResult(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    setShowPrintFormat(true);
    setTimeout(() => {
      const printContent = printRef.current;
      const printWindow = window.open('', '_blank');
      
      printWindow.document.write(`
        <html>
          <head>
            <title>Impresión de Etiquetas</title>
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet">
            <style>
              body {
                font-family: Arial, sans-serif;
                font-size: 12px;
                margin: 0;
                padding: 10px;
              }
              .print-container {
                width: 100%;
              }
              .print-header-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 15px;
                border: 1px solid #000;
              }
              .print-header-table td {
                border: 1px solid #000;
                padding: 6px 8px;
                vertical-align: top;
              }
              .print-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 15px;
                font-size: 10px;
              }
              .print-table, .print-table th, .print-table td {
                border: 1px solid #000;
              }
              .print-table th, .print-table td {
                padding: 4px;
                text-align: center;
              }
              .compact-row {
                height: 25px;
              }
              .signature-section {
                margin-top: 20px;
              }
              .signature-line {
                border-top: 1px solid #000;
                margin-top: 30px;
                padding-top: 5px;
              }
              .page-break {
                page-break-after: always;
                margin-bottom: 20px;
              }
              .page-break:last-child {
                page-break-after: avoid;
              }
              .text-left {
                text-align: left !important;
              }
              .bold {
                font-weight: bold;
              }
              .materiales-table {
                font-size: 9px;
              }
              .materiales-table td {
                height: 25px;
              }
              @media print {
                body { margin: 0; }
                .no-print { display: none !important; }
              }
            </style>
          </head>
          <body>
            ${printContent.innerHTML}
          </body>
        </html>
      `);
      
      printWindow.document.close();
      printWindow.focus();
      
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }, 500);
  };

  // Parsear los datos generados si existen
  const parsedData = result && result.datos_Generados ? JSON.parse(result.datos_Generados) : null;

  // Componente para el formato de impresión
  const PrintFormat = ({ data }) => {
    if (!data || data.length === 0) return null;

    return (
      <div className="print-format" ref={printRef} style={{ display: 'none' }}>
  {data.map((item, index) => (
    <div key={index} className="print-container" style={{ 
      fontSize: '9px', 
      lineHeight: '1',
      padding: '3mm',
      margin: '0',
      fontFamily: 'Arial, sans-serif',
      position: 'relative'
    }}>
      
      {/* ENCABEZADO DE EMPRESA CON LOGO Y CÓDIGO */}
      <div style={{ 
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '8px',
        borderBottom: '2px solid #000',
        paddingBottom: '4px'
      }}>
        {/* LADO IZQUIERDO - INFORMACIÓN DE EMPRESA */}
        <div style={{ textAlign: 'left' }}>
          <div style={{ fontSize: '11px', fontWeight: 'bold' }}>
            <img 
              src="/favicon.ico" 
              alt="Logo Parma" 
              style={{ 
                width: '16px', 
                height: '16px', 
                verticalAlign: 'middle',
                marginRight: '5px'
              }} 
            />
            Fabrica de productos Lacteos Parma. S.A.
          </div>
          <div style={{ fontSize: '9px', fontWeight: 'bold' }}>
            Departamento de Produccion
          </div>
          <div style={{ fontSize: '8px' }}>
            Area: Cocina - Peso de formas
          </div>
        </div>

        {/* LADO DERECHO - CÓDIGO Y VERSIÓN */}
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: '8px', fontWeight: 'bold' }}>
            CODIGO: R.PD.012.0300
          </div>
          <div style={{ fontSize: '8px', fontWeight: 'bold' }}>
            Versión: 3.0
          </div>
        </div>
      </div>
<br />
      {/* ENCABEZADO CON ESTRUCTURA ORIGINAL Y LÍNEAS */}
      <table className="print-header-table" style={{ 
        width: '100%', 
        marginBottom: '6px',
        borderCollapse: 'collapse',
        border: '1px solid #000'
      }}>
        <tbody>
          <tr>
            <td width="25%" style={{ padding: '2px', border: '1px solid #000' }}>
              <strong>Fecha:</strong> 
            </td>
            <td width="25%" style={{ padding: '2px', border: '1px solid #000' }}>
            {new Date().toLocaleDateString()}
            </td>
            <td width="25%" style={{ padding: '2px', border: '1px solid #000', fontWeight: 'bold' }}>
              Producción
            </td>
            <td width="25%" style={{ padding: '2px', border: '1px solid #000', fontWeight: 'bold' }}>
              Información
            </td>
          </tr>
          <tr>
            <td style={{ padding: '2px', border: '1px solid #000', fontWeight: 'bold' }}>
              Lote:
            </td>
            <td style={{ padding: '2px', border: '1px solid #000' }}>
              {formData.lote} 
            </td>
            <td style={{ padding: '2px', border: '1px solid #000' }}>
              #OF- Sap
            </td>
            <td style={{ padding: '2px', border: '1px solid #000' }}>
              {/* Espacio vacío para alineación */}
            </td>
          </tr>
          <tr>
            <td style={{ padding: '2px', border: '1px solid #000', fontWeight: 'bold' }}>
              Encajador:
            </td>
            <td style={{ padding: '2px', border: '1px solid #000' }}>
               {item.CE_USUARIOCREACION}
            </td>
            <td style={{ padding: '2px', border: '1px solid #000' }}>
              Bodega
            </td>
            <td style={{ padding: '2px', border: '1px solid #000' }}>
              {/* Espacio vacío para alineación */}
            </td>
          </tr>
          {/* Fila adicional para información del producto */}
          <tr>
            <td style={{ padding: '2px', border: '1px solid #000', fontWeight: 'bold' }}>
              Producto:
            </td>
            <td style={{ padding: '2px', border: '1px solid #000' }} colSpan="3">
              {formData.producto} - {item.CE_NOMBRE_PRODUCTO || 'Descripción del producto'}
            </td>
          </tr>
        </tbody>
      </table>

      {/* TABLA PRINCIPAL CON 36 FILAS Y LÍNEAS */}
      <div style={{ marginBottom: '6px' }}>
        <table style={{ 
          width: '100%', 
          fontSize: '8px',
          borderCollapse: 'collapse',
          border: '1px solid #000'
        }}>
          <thead>
            <tr style={{ height: '16px', backgroundColor: '#f5f5f5' }}>
              <th width="8%" style={{ padding: '1px', border: '1px solid #000',  textAlign: 'center'}}># Forma</th>
              <th width="12%" style={{ padding: '1px', border: '1px solid #000' ,  textAlign: 'center'}}>Peso KG</th>
              <th width="15%" style={{ padding: '1px', border: '1px solid #000' ,  textAlign: 'center'}}>Rev Visual B-M</th>
              <th width="12%" style={{ padding: '1px', border: '1px solid #000' ,  textAlign: 'center'}}>Ingreso √</th>
              <th width="15%" style={{ padding: '1px', border: '1px solid #000' ,  textAlign: 'center'}}>Fecha Salida</th>
              <th width="18%" style={{ padding: '1px', border: '1px solid #000' ,  textAlign: 'center'}}>Área/Destino</th>
              <th width="20%" style={{ padding: '1px', border: '1px solid #000' ,  textAlign: 'center'}}>Responsable</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 36 }, (_, i) => i + 1).map(num => (
              <tr key={num} style={{ height: '14px' }}>
                <td style={{ padding: '1px', border: '1px solid #000', textAlign: 'center' }}>{num}</td>
                <td style={{ padding: '1px', border: '1px solid #000', textAlign: 'center' }}>
                  {item.det && item.det[num - 1] ? 
                   (parseFloat(item.det[num - 1].CD_PESO) || '').toFixed(2) : ''}
                </td>
                <td style={{ padding: '1px', border: '1px solid #000' }}></td>
                <td style={{ padding: '1px', border: '1px solid #000' }}></td>
                <td style={{ padding: '1px', border: '1px solid #000' }}></td>
                <td style={{ padding: '1px', border: '1px solid #000' }}></td>
                <td style={{ padding: '1px', border: '1px solid #000' }}></td>
              </tr>
            ))}
            <tr style={{ height: '14px', fontWeight: 'bold' }}>
              <td style={{ padding: '1px', border: '1px solid #000', textAlign: 'center' }}>Total</td>
              <td style={{ padding: '1px', border: '1px solid #000', textAlign: 'center' }}>
                {item.det ? item.det.reduce((sum, det) => sum + (parseFloat(det.CD_PESO) || 0), 0).toFixed(2) : '0.00'}
              </td>
              <td style={{ padding: '1px', border: '1px solid #000' }}></td>
              <td style={{ padding: '1px', border: '1px solid #000' }}></td>
              <td style={{ padding: '1px', border: '1px solid #000' }}></td>
              <td style={{ padding: '1px', border: '1px solid #000' }}></td>
              <td style={{ padding: '1px', border: '1px solid #000' }}></td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* INFORMACIÓN DE TARIMA CON LÍNEAS */}
      <div style={{ marginBottom: '4px' }}>
        <table style={{ 
          width: '100%', 
          fontSize: '8px',
          borderCollapse: 'collapse',
          border: '1px solid #000'
        }}>
          <tbody>
            <tr>
              <td width="20%" style={{ padding: '2px', border: '1px solid #000', fontWeight: 'bold' }}>Tarima No.</td>
              <td width="30%" style={{ padding: '2px', border: '1px solid #000' }}></td>
              <td width="50%" style={{ padding: '2px', border: '1px solid #000' }} colSpan="2">
                LIBERADO __________________ REPROCESO ____________________
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* NOTAS COMPLETAS */}
      <div style={{ fontSize: '7px', marginBottom: '4px', lineHeight: '1' }}>
        <p style={{ margin: '1px 0' }}>
          <strong>*Notas:</strong> Colocar B= Bueno, M= Malo. Si se detecta algún contaminante, identificar inmediatamente e informar a Supervisión y/o Control de Calidad sobre el hallazgo.
        </p>
        <p style={{ margin: '1px 0' }}>
          *Para tarimas, revisar que estén completas, sin astillas o clavos salidos, en buen estado, colocar B= Bueno, M= Malo  Bueno____, Malo____,
        </p>
      </div>

      {/* FIRMAS CON LÍNEAS */}
      <div style={{ marginBottom: '6px' }}>
        <table style={{ 
          width: '100%', 
          fontSize: '7px',
          borderCollapse: 'collapse'
        }}>
          <tbody>
            <tr>
              <td width="25%" className="text-center">
                <div style={{ 
                  borderBottom: '1px solid black', 
                  height: '10px', 
                  marginBottom: '1px',
                  width: '80%',
                  margin: '0 auto'
                }}></div>
                Vo. Bo. Encajador
              </td>
              <td width="25%" className="text-center">
                <div style={{ 
                  borderBottom: '1px solid black', 
                  height: '10px', 
                  marginBottom: '1px',
                  width: '80%',
                  margin: '0 auto'
                }}></div>
                Vo. Bo. Supervisor
              </td>
              <td width="25%" className="text-center">
                <div style={{ 
                  borderBottom: '1px solid black', 
                  height: '10px', 
                  marginBottom: '1px',
                  width: '80%',
                  margin: '0 auto'
                }}></div>
                Vo. Bo. Bodega
              </td>
              <td width="25%" className="text-center">
                <div style={{ 
                  borderBottom: '1px solid black', 
                  height: '10px', 
                  marginBottom: '1px',
                  width: '80%',
                  margin: '0 auto'
                }}></div>
                Vo. Bo. Calidad
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* MATERIAL DE EMPAQUE CON LÍNEAS */}
      <div>
        <h6 style={{ 
          fontSize: '8px', 
          textAlign: 'center', 
          margin: '2px 0',
          fontWeight: 'bold'
        }}>
          CONSUMO MATERIAL DE EMPAQUE
        </h6>
        <table style={{ 
          width: '100%', 
          fontSize: '7px',
          borderCollapse: 'collapse',
          border: '1px solid #000'
        }}>
          <thead>
            <tr style={{ height: '14px', backgroundColor: '#f5f5f5' }}>
             <th width="15%"  style={{ padding: '1px', border: '1px solid #000', textAlign: 'center' }}>UNIDADES</th>
              <th width="20%" style={{ padding: '1px', border: '1px solid #000',  textAlign: 'center' }}>CODIGO</th>
              <th width="45%" style={{ padding: '1px', border: '1px solid #000',  textAlign: 'center' }}>DESCRIPCIÓN</th>   
              <th width="20%" style={{ padding: '1px', border: '1px solid #000',  textAlign: 'center' }}>LOTE</th>
            </tr>
          </thead>
          <tbody>
            {materialesEmpaque.map((material, idx) => (
              <tr key={idx} style={{ height: '12px' }}>
                <td style={{ padding: '1px', border: '1px solid #000' }}></td>
                <td style={{ padding: '1px', border: '1px solid #000' }}>{material.codigo}</td>
                <td style={{ padding: '1px', border: '1px solid #000', textAlign: 'left' }}>{material.descripcion}</td>
                <td style={{ padding: '1px', border: '1px solid #000' }}></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PIE DE PÁGINA - INFORMACIÓN CONFIDENCIAL */}
      <div style={{ 
        textAlign: 'center', 
        marginTop: '10px',
        borderTop: '2px solid #000',
        paddingTop: '4px',
        fontSize: '7px',
        fontWeight: 'bold'
      }}>
        <div>Esta información es exclusiva y confidencial de Fábrica de Productos Lácteos Parma S.A.</div>
        <div>Prohibido la divulgación distribución y/o reproducción parcial o total de este documento.</div>
      </div>

      {index < data.length - 1 && <div className="page-break"></div>}
    </div>
  ))}
</div>
    );
  };

  return (
    <div className="container-fluid px-0">
      {/* Header */}
      <header className="bg-primary text-white text-center py-4 mb-4 shadow no-print">
        <h1 className="display-5 fw-bold">Búsqueda de Etiquetas</h1>
        <p className="lead">Sistema de consulta de productos y lotes</p>
      </header>

      <main className="container mb-5 no-print">
        {/* Formulario de búsqueda */}
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="card shadow">
              <div className="card-header bg-light">
                <h5 className="card-title mb-0">Formulario de Búsqueda</h5>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="producto" className="form-label">Producto:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="producto"
                        name="producto"
                        value={formData.producto}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label htmlFor="lote" className="form-label">Lote:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="lote"
                        name="lote"
                        value={formData.lote}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="d-grid">
                    <button 
                      type="submit" 
                      className="btn btn-primary btn-lg"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Buscando...
                        </>
                      ) : 'Buscar'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Mensaje de error */}
        {error && (
          <div className="row justify-content-center mt-4">
            <div className="col-md-8">
              <div className="alert alert-danger d-flex align-items-center" role="alert">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16">
                  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                </svg>
                <div>
                  <h5 className="alert-heading">Error en la búsqueda</h5>
                  <p className="mb-0">{error}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Resultados y botón de impresión */}
        {parsedData && parsedData.length > 0 && (
          <div className="row justify-content-center mt-4">
            <div className="col-md-10">
              <div className="card shadow">
                <div className="card-header bg-success text-white d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">
                    Resultados de: <strong>{formData.producto}</strong> - Lote: <strong>{formData.lote}</strong>
                  </h5>
                  <button 
                    className="btn btn-light btn-sm"
                    onClick={handlePrint}
                  >
                    <i className="bi bi-printer me-2"></i>
                    Imprimir Formato
                  </button>
                </div>
                <div className="card-body">
                  {parsedData.map((item, index) => (
                    <div key={index} className="product-card mb-4 p-3 border rounded">
                      <h4 className="text-primary">Producto: {item.CE_PRODUCTO}</h4>
                      <div className="row">
                        <div className="col-md-6">
                          <p><strong>Nombre:</strong> {item.CE_NOMBRE_PRODUCTO}</p>
                          <p><strong>Código:</strong> {item.CE_CODIGO}</p>
                          <p><strong>Fecha creación:</strong> {new Date(item.CE_FECHACREACION).toLocaleString()}</p>
                        </div>
                        <div className="col-md-6">
                          <p><strong>Cantidad producida:</strong> {item.CE_CANTIDADPRODUCIDA}</p>
                          <p><strong>Usuario creación:</strong> {item.CE_USUARIOCREACION}</p>
                        </div>
                      </div>
                      
                      <h5 className="mt-3 border-top pt-2">Detalles del lote:</h5>
                      {item.det && item.det.map((detalle, detIndex) => (
                        <div key={detIndex} className="lot-details p-3 bg-light rounded mt-2">
                          <div className="row">
                            <div className="col-md-6">
                              <p><strong>Lote:</strong> {detalle.CD_LOTE}</p>
                              <p><strong>Fecha vencimiento:</strong> {detalle.CD_FECHAVENCIMIENTO}</p>
                              <p><strong>Número de cajilla:</strong> {detalle.CD_NUM_CAJILLA}</p>
                            </div>
                            <div className="col-md-6">
                              <p><strong>Unidades:</strong> {detalle.CD_UNIDADES}</p>
                              <p><strong>Peso:</strong> {detalle.CD_PESO}</p>
                              <p><strong>Tara:</strong> {detalle.CD_TARA}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Sin resultados */}
        {parsedData && parsedData.length === 0 && (
          <div className="row justify-content-center mt-4">
            <div className="col-md-8">
              <div className="alert alert-info text-center" role="alert">
                <h4 className="alert-heading">No se encontraron resultados</h4>
                <p>No hay datos para los criterios de búsqueda ingresados.</p>
              </div>
            </div>
          </div>
        )}
      </main>

      {/* Formato de impresión */}
      {showPrintFormat && parsedData && (
        <PrintFormat data={parsedData} />
      )}

      {/* Footer */}
      <footer className="bg-dark text-white text-center py-3 mt-5 no-print">
        <div className="container">
          <p className="mb-0">Sistema de Búsqueda de Etiquetas - {new Date().getFullYear()}</p>
        </div>
      </footer>
    </div>
  );
};

export default Cxp;